import React from 'react';
import './css/GroupIntroduction.css';
import NavBox from '../components/NavBox';
const GroupIntroduction: React.FC = () => {


    return (
        <div className="page-container">
            <NavBox />
            <div className="content-area1">
                <h1 className="content-title1">Группийн танилцуулга</h1>
                <div className="image-section1">
                    <img
                        src="https://mcs.mn/wp-content/uploads/2024/12/Entrepreneur-2024-1300x731.jpg"
                        alt="Workspace"
                        className="content-image1"
                    />
                </div>

                <div className="text-section">
                    <p className="content-text">
                        Эрчим хүчний зөвлөгөө өгөх чиглэлээр 1993 онд үүсгэн байгуулагдсан М-Си-Эс компани шилжилтийн он жилүүдэд олон салбарт бизнесийн үйл ажиллагаа эрхлэн, улсын нийгэм, эдийн засгийн хөгжилд хувь нэмрээ оруулсаар ирсэн бөгөөд өдгөө татвар шимтгэл, хөрөнгө оруулалт, ажлын байр зэрэг үзүүлэлтээр тэргүүлэгч үндэсний томоохон Групп болоод байна. Аливаа улс орны хөгжлийг шинэ шатанд хүргэдэг дэд бүтэц, эрчим хүч, инженеринг, мэдээлэл, харилцаа холбоо, барилга, үл хөдлөх хөрөнгийн салбар, эдийн засгийг үлэмж тэтгэдэг уул уурхай, өргөн хэрэглээний бараа бүтээгдэхүүнийн салбар, нийгмийн сайн сайхан, хүний хөгжлийг дэмждэг эрүүл мэнд, боловсрол зэрэг чухал салбарт ажилласан он жилүүддээ бид тогтсон байгууллагын соёлтой, төлөвшсөн боловсон хүчинтэй, түүчээлэх өрсөлдөх чадвартай Групп болон тэлжээ.
                    </p>
                    <p className="content-text">
                        Өдөрт 3.6 тэрбум, сард 108 гаруй тэрбум төгрөгийн татвар, шимтгэлийг улсын төсөвт төвлөрүүлж, өөрийн 14,000 ажилтандаа сард 58 тэрбум төгрөгийн цалин олгохоос гадна дотоодын 8600 гаруй бизнес эрхлэгчээс сард 258 тэрбум төгрөгийн бараа, ажил үйлчилгээ худалдан авч, шууд бусаар мөн 20,000 хүнийг тогтмол ажлын байртай болгож, сард доод тал нь 20 орчим тэрбум төгрөгийн цалин тавих боломжийг олгон улс орны нийгэм, эдийн засгийн хөгжилд бодитой, том хувь нэмрийг оруулж байна.
                    </p>
                    <p className="content-text">
                        Бизнесийн цар хүрээ тэлж, компаниуд маань өсч томрохын хэрээр нийгэм, улс орныхоо өмнө хүлээх бидний үүрэг, хариуцлага улам бүр өндөрсөж, дэлхийн стандарт, дэвшилтэт техник, технологийг эх орондоо нэвтрүүлж, нийгмийн өмнө хүлээсэн хариуцлагаа бүрэн дүүрэн хэрэгжүүлэхийг эрхэм зорилгоо болгон ажиллаж байна.
                    </p>
                </div>
            </div>
        </div>
    );
};


export default GroupIntroduction;



